import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function(state=initialState.products, action) {
  switch (action.type) {
    case types.GET_PRODUCTS_REQUEST:
      return {
        data: state.data,
        isFetching: true
      }

    case types.GET_PRODUCTS_SUCCESS:
      return {
        data: action.data,
        isFetching: false,
        errors: state.errors
      }

    case types.GET_PRODUCTS_FAILURE:
      return {
        data: state.data,
        isFetching: false,
        errors: action.messages
      }

    case types.GET_MORE_PRODUCTS_REQUEST:
      return Object.assign({}, state, {
        isFetchingMore: true,
      })
    case types.GET_MORE_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        isFetchingMore: false,
        errorMessage: '',
        data: {
          ...state.data,
          ...action.data,
          results: [
            ...state.data.results,
            ...action.data.results
          ]
        }
      })
    case types.GET_MORE_PRODUCTS_FAILURE:
      return Object.assign({}, state, {
        isFetchingMore: false,
        errorMessage: {
          ...action.messages
        }
      })

    case types.BUY_PACK_REQUEST:
      return Object.assign({}, state, {
        buy: {
          ...state.buy,
          isFetching: true,
        }
      })

    case types.BUY_PACK_RECEIVE:
      return Object.assign({}, state, {
        buy: {
          isFetching: false,
          data: action.data,
          errors: null
        }
      })

    case types.BUY_PACK_FAILURE:
      return Object.assign({}, state, {
        buy: {
          isFetching: false,
          data: null,
          errors: action.messages 
        }
      })

    case types.ADD_PACK_LIKE_REQUEST:
      return Object.assign({}, state, {
        likeIsFetching: true
      })
    case types.ADD_PACK_LIKE_SUCCESS:
      state.data.results.map(pack => {
        if(pack.id === action.pack.id){
          pack.likes_count = (action.pack.likes_count+1)
          pack.is_already_liked = !pack.is_already_liked
        }
      });
      return Object.assign({}, state, {
        likeIsFetching: false,
        data: {
          ...state.data
        }
      });

    case types.ADD_PACK_DISLIKE_REQUEST:
      return Object.assign({}, state, {
        disLikeIsFetching: true
      })
    case types.ADD_PACK_DISLIKE_SUCCESS:
      state.data.results.map(pack => {
        if(pack.id === action.pack.id){
          pack.dislikes_count = (action.pack.dislikes_count+1)
          pack.is_already_disliked = !pack.is_already_disliked
        }
      });
      return Object.assign({}, state, {
        disLikeIsFetching: false,
        data: {
          ...state.data
        }
      });

    case types.RESET_ALL_INFO:
      return initialState.products;

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/buyReducer.js